import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { IConfirmConfig } from './confirm.config';

@Injectable()
export class ConfirmService {

    confirm = new Subject<boolean>();
    private _confirmConfig: IConfirmConfig;


    constructor() { }

    set confirmConfig(confirmConfig: IConfirmConfig) {
        this._confirmConfig = confirmConfig;
    }

    get confirmConfig() {
        return this._confirmConfig;
    }

    observerConfirm(): Observable<boolean> {
        return this.confirm.asObservable();
    }

    showConfirm(show: boolean) {
        this.confirm.next(show);
    }


}
